// src/components/common/tableCustomization.ts
// Shared types for data-table customize drawers (COA, Bank transactions, future tables).

export type Density = 'compact' | 'standard' | 'spacious';

export interface TableColumnDef {
  key: string;
  label: string;
  /** Whether the user can hide this column. Default true. (Checkboxes/actions stay fixed.) */
  togglable?: boolean;
  defaultVisible?: boolean;
}

export interface TableCustomization {
  columns: Array<{ key: string; visible: boolean; order: number }>;
  density: Density;
  numberFormat: {
    hideCurrencySymbol: boolean;
    negativeStyle: 'parentheses' | 'minus';
  };
}

export function buildDefaultCustomization(defs: TableColumnDef[]): TableCustomization {
  return {
    columns: defs.map(function (c, i) { return { key: c.key, visible: c.defaultVisible !== false, order: i }; }),
    density: 'compact',
    numberFormat: {
      hideCurrencySymbol: false,
      negativeStyle: 'parentheses',
    },
  };
}

export function visibleOrderedColumns(c: TableCustomization): Array<{ key: string; order: number }> {
  return [...c.columns].filter(function (col) { return col.visible; }).sort(function (a, b) { return a.order - b.order; });
}

export function densityPaddingClass(d: Density): string {
  if (d === 'compact') return 'py-2';
  if (d === 'spacious') return 'py-4';
  return 'py-3';
}